import axios from "axios";

const instance = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "https://urchin-app-49cxg.ondigitalocean.app/",
});

export default instance;
